import { useState, useEffect } from 'react';
import { Button, Checkbox } from '@material-tailwind/react';
import { Breadcrumbs } from 'components/breadcrumbs';
import useWindowWidth from 'utills/InitWidthDevice';
import { useParse, useTranslation } from '@refinedev/core';
import ApiService from 'utills/ApiService';
import { DEFAULT_PERMISSIONS } from 'utills/constants';
import toast from 'react-hot-toast';
import { Formik, Field, Form } from 'formik';
import { SwitchButton } from 'components/switchButton';
import { FullScreenLoading } from 'components/fullScreenLoading';
import { useNavigate } from 'react-router-dom';

const FormCreateRole = (props: any) => {
  const { translate, isMobile, token } = props;

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(true);

  const [permission, setPermission] = useState([] as any);

  const [fetchData, setFetchData] = useState(false);

  useEffect(() => {
    if (token && token !== '') {
      const intervalFetchData = setInterval(() => {
        setFetchData(true);
        clearInterval(intervalFetchData);
      }, 100);
    }
  }, [token]);

  useEffect(() => {
    if (fetchData) {
      fetchListPermission();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchData]);

  const fetchListPermission = async () => {
    setLoading(true);
    try {
      const result = await ApiService.get(`role/organization/permissions`, token);

      if (result && result.length > 0) {
        const arr = [...DEFAULT_PERMISSIONS] as any;

        arr.forEach((item: any) => {
          for (let i = 0; i < result.length; i++) {
            const id = (result[i].resource === '') ? result[i].app : result[i].resource;
            const isPermissionMatched = result[i].resource === item.resource && result[i].app === item.app;

            if (isPermissionMatched) {
              if (result[i].action.length === 3) {
                item.disable = false;

                item.actions.forEach((action: any) => {
                  action.selected = false;
                  action.disable = false;
                })
              } else {
                if (result[i].action.length > 0) {
                  item.disable = false;

                  for (let j = 0; j < result[i].action.length; j++) {
                    item.actions.forEach((action: any, index: number) => {
                      if (index === 0) {
                        action.disable = false;
                      }

                      if (result[i].action[j] === action.id) {
                        action.selected = false;
                        action.disable = false;
                      }
                    })
                  }
                }
              }

            }

            if (result[i].app === item.id && !item.child) {
              item.disable = false;
            }
          }
        });


        setPermission([...arr]);
      }
    } catch (error: any) {
      toast.error(error.message);
    }

    setLoading(false);
  }

  const handleSubmit = async (values: any, { setSubmitting }: any) => {
    setLoading(true);
    const permissionData: any[] = [];

    permission.forEach((item: any) => {
      if (item.actions.length > 0) {
        const obj = {
          resource: item.resource ?? '',
          app: item.app ?? '',
          actions: []
        } as any;

        for (let i = 0; i < item.actions.length; i++) {
          if (item.actions[i].id !== 'all') {
            if (item.actions[i].selected) {
              obj.actions.push(item.actions[i].id);
            }
          }
        }

        permissionData.push(obj);
      }
    })

    const submitData = {
      name: values.role_name,
      description: values.role_description,
      is_active: status,
      permissions: permissionData
    };

    try {
      const result = await ApiService.post(`role`, submitData, token);

      if (result) {
        toast.success(translate('create-successfully'));
        navigate(`/organization/role`);
      }
    } catch (error: any) {
      toast.error(error.message);
    }

    setSubmitting(false);

    setLoading(false);
  }

  const validateText = (value: string) => {
    let error;

    if (!value) {
      error = translate("error-field-require");
    } else {
      let str = value;
      str = str.toLowerCase();
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
      str = str.replace(/đ/g, 'd');
      const regex = /[^a-zA-Z0-9 ]+/;

      if (regex.test(str)) {
        error = translate("error-special-character");
      }
    }

    return error;
  }

  const handleSelectAction = (value: boolean, checkboxId: string, selectedPermission: any) => {
    setLoading(true);
    const permission_temp = [...permission];
    permission_temp.forEach((item: any) => {
      const isPermissionMatched = selectedPermission.resource === item.resource && selectedPermission.app === item.app;
      if (isPermissionMatched) {
        for (let i = 0; i < item.actions.length; i++) {
          if (checkboxId === 'all') {
            if (!item.actions[i].disable) {
              item.actions[i].selected = value;
            }
          } else {
            if (item.actions[i].id === checkboxId) {
              item.actions[i].selected = value;
            }
          }
        }

        if (!value) {
          item.actions[0].selected = false;
        } else {
          let check_all = true;

          item.actions.forEach((item: any) => {
            if (item.id !== 'all' && !item.selected && !item.disable) {
              check_all = false;
            }
          });

          item.actions[1].selected = true;

          if (check_all) {
            item.actions[0].selected = true;
          }
        }
      }

    });

    permission_temp.forEach((item: any) => {
      if (item.actions.length > 0) {
        let action_count = 0;
        let all = 0;

        item.actions.forEach((action: any) => {
          if (!action.disable) {
            action_count = action_count + 1;
          }

          if (action.selected) {
            all = all + 1;
          };
        });

        if (all === action_count - 1) {
          item.actions[0].selected = true;
        }

      }
    });

    setPermission([...permission_temp]);
    setLoading(false);
  }

  return (
    <div className="w-full bg-white relative">
      <Formik
        initialValues={{ role_name: '', role_description: '' }}
        onSubmit={(values, { setSubmitting }) => handleSubmit(values, { setSubmitting })}
      >
        {({
          handleSubmit,
          isSubmitting
        }) => (
          <Form onSubmit={handleSubmit}>
            <div className="form">
              <div className="w-full px-[16px] h-[58px] border-b border-[#c5ccd2] flex items-center text-16 font-500">{translate('create-new-role')}</div>
              <div className="w-full p-[16px] grid grid-cols-1 gap-[12px]">
                <div className={`w-full ${isMobile ? 'grid grid-cols-1 gap-[12px]' : 'grid grid-cols-2'}`}>
                  <div className="w-full">
                    <div className="w-full flex items-center gap-[8px] text-14 font-500 mb-[4px]">
                      <span className="form-label">{translate('status')}</span>

                      <img src="/images/icons/icon-require.svg" alt="icon-require" className="icon-require" />
                    </div>

                    <SwitchButton checked={status} onChange={() => setStatus(!status)} />
                  </div>

                  <div className="w-full">
                    <div className="w-full flex items-center gap-[8px] text-14 font-500 mb-[4px]">
                      <span className="form-label">{translate('role-name')}</span>

                      <img src="/images/icons/icon-require.svg" alt="icon-require" className="icon-require" />
                    </div>

                    <Field name="role_name" validate={validateText}>
                      {({
                        field,
                        meta,
                      }: any) => (
                        <div className="field-group">
                          <input {...field} type="text" className="w-full rounded-[4px] border border-[#c5ccd2]" autoComplete="off" placeholder={translate('role-name')} maxLength={50} />

                          <div className="text-14 text-[#a8b3bd] mt-[4px] w-full text-right">{field.value ? field.value.length : 0}/50</div>

                          {meta.touched && meta.error && (
                            <div className="text-12 text-[#ff0000] mt-[4px]">{meta.error}</div>
                          )}
                        </div>
                      )}
                    </Field>

                  </div>
                </div>

                <div className="w-full">
                  <div className="w-full">
                    <div className="text-14 font-500 mb-[8px]">
                      <span className="form-label">{translate('role-description')}</span>
                    </div>

                    <Field name="role_description">
                      {({
                        field,
                        meta,
                      }: any) => (
                        <div className="field-group full">
                          <input {...field} type="text" className="w-full rounded-[4px] border border-[#c5ccd2]" autoComplete="off" placeholder={translate('role-description')} maxLength={100} />

                          <div className="text-14 text-[#a8b3bd] mt-[4px] w-full text-right">{field.value ? field.value.length : 0}/100</div>

                          {meta.touched && meta.error && (
                            <div className="text-12 text-[#ff0000] mt-[4px]">{meta.error}</div>
                          )}
                        </div>
                      )}
                    </Field>

                  </div>
                </div>

                <div className="w-full">
                  <div className="form-item">
                    <div className="text-14 flex items-center gap-[4px] font-500 mb-[8px]">
                      <span className="form-label">{translate('access-permission')}</span>

                      <img src="/images/icons/icon-require.svg" alt="icon-require" className="icon-require" />
                    </div>

                    <div className={`${isMobile ? 'mt-[8px]' : 'mt-[32px] gap-[8px]'} w-full grid grid-cols-1`}>
                      {
                        permission.map((item: any, index: number) => {
                          return (
                            <div className={`w-full bg-[#f6f5fe80] ${isMobile ? `p-[16px] flex flex-col rounded-[8px] ${!item.child && 'mt-[8px]'}` : 'h-[40px] flex items-center justify-between p-[24px]'} ${item.child && 'border-t border-[#c5ccd2]'}`} key={`${item.name}_${index}`} style={{ display: item.disable && 'none' }}>
                              <div className={`${isMobile ? 'w-full' : 'w-[30%]'} flex items-center gap-[8px]`}>
                                {
                                  item.icon !== '' &&
                                  <img src={item.icon} alt="icon-permission" className="icon-permission" />
                                }
                                <div className="role-label">{translate(item.name)}</div>
                              </div>

                              <div className={`${isMobile ? 'w-full grid grid-cols-2 gap-[8px]' : 'flex-1 flex items-center justify-between'}`}>
                                {
                                  item.actions.map((checkboxItem: any) => {
                                    return (
                                      <div className="flex items-center gap-[8px]" key={checkboxItem.label} style={{ visibility: (checkboxItem.disable) && 'hidden' }}>
                                        <Checkbox
                                          onChange={() => handleSelectAction(!checkboxItem.selected, checkboxItem.id, item)}
                                          checked={checkboxItem.disable ? false : checkboxItem.selected}
                                          className="checked:bg-[#f1600d] checked:border-[#f1600d]"
                                          disabled={checkboxItem.disable}
                                          {...{} as any}
                                        />

                                        <div className="checkbox-label">{translate(checkboxItem.label)}</div>
                                      </div>
                                    )
                                  })
                                }
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div className="w-full h-[80px] px-[24px] fixed bottom-0 bg-white left-0 flex items-center justify-end gap-[12px]">
              <Button
                {...{} as any}
                className="h-[48px] flex items-center justify-center gap-x-[16px] border border-brand-500 text-brand-500 font-600 bg-white" onClick={() => {
                  window.location.href = `/organization/role`
                }}>{translate('btn-cancel')}</Button>
              <Button
                {...{} as any}
                type="submit" disabled={isSubmitting} className="h-[48px] flex items-center justify-center gap-x-[16px] border border-brand-500 text-white font-600 bg-brand-500">{translate('btn-save')}</Button>
            </div>

            {
              loading &&
              <FullScreenLoading />
            }
          </Form>
        )}
      </Formik>
    </div>
  )
}

const WPSRolesCreate = () => {
  const windowWidth = useWindowWidth();
  const [isMobile, setIsMobile] = useState(false);
  const { translate } = useTranslation();
  const [token, setToken] = useState('');

  useEffect(() => {
    const user = localStorage.getItem("USER");

    if (user) {
      const userData = JSON.parse(user);
      setToken(userData?.token);
    }
  }, []);

  const breadcrumbItems = [
    {
      label: translate('organization'),
      href: ''
    },
    {
      label: translate('role-management'),
      href: '/organization/role'
    },
    {
      label: translate('create-new-role'),
      href: ''
    },
  ];

  useEffect(() => {
    if (windowWidth && windowWidth < 1024) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [windowWidth]);

  return (
    <div className="w-full">
      <Breadcrumbs type="wps" breadcrumbItems={breadcrumbItems} />

      {
        (token !== '') &&
        <div className={`w-full ${isMobile ? 'p-[16px]' : 'pt-[16px] px-[10%] pb-[100px]'}`}>
          <FormCreateRole
            isMobile={isMobile}
            translate={translate}
            token={token} />
        </div>
      }

    </div>
  )
};

export default WPSRolesCreate;